import { render, staticRenderFns } from "./FrostedCard.vue?vue&type=template&id=6eb3eeb6&scoped=true&"
import script from "./FrostedCard.vue?vue&type=script&lang=js&"
export * from "./FrostedCard.vue?vue&type=script&lang=js&"
import style0 from "./FrostedCard.vue?vue&type=style&index=0&id=6eb3eeb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb3eeb6",
  null
  
)

export default component.exports